import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	Grid,
	Paper,
	Typography,
} from "@mui/material";
const useStyles = makeStyles((theme) => ({}));
import clsx from "clsx";
import { makeStyles, withStyles } from "@mui/styles";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { green, } from "@mui/material/colors";

const ColorButton = withStyles((theme) => ({
	root: {
		color: white,
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
}))(Button);

export default function AmbassadorAppointment({ id }) {
	const [state, setState] = useState({ mails: [] });
	const [attended, setAttended] = useState(false);
	const [happy, setHappy] = useState(false);
	const classes = useStyles();

	const handleChange = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};
	const confirmMeeting = () => {
		fetch("/api/confirm/" + id)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.replace(res.r);
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const attendeeHere = (pld) => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(pld),
		};

		fetch("/api/setatt/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.replace(window.location.href);
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		fetch("/api/aptmnt/" + id)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState(res.pld);
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);

	return (
		<div style="paddding: 20px; margin: 20px;">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						<Typography variant="h5">Gestion de rendez-vous pour {state.n}</Typography>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						<Box display="flex" justifyContent="flex-start" alignItems="space-between" flexDirection="row">
							<Box>
								<AccessTimeIcon style="margin-right: 10px;" />
							</Box>
							<Box>
								<Typography variant="h6">{state.dbt}</Typography>
							</Box>
						</Box>
						<Box display="flex" justifyContent="flex-start" alignItems="space-between" flexDirection="row">
							<Box>
								<LocationOnIcon style="margin-right: 10px;" />
							</Box>
							<Box>
								<Typography variant="h6">{state.a}</Typography>
							</Box>
						</Box>
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						{!state.c && (
							<Grid container alignContent="space-between">
								<Grid item xs={6}>
									<Button onClick={confirmMeeting}>Je confirme</Button>
								</Grid>
								<Grid item xs={6}>
									<Button>Je décale le rendez-vous</Button>
								</Grid>
							</Grid>
						)}
						{state.c && (
							<Box display="flex" justifyContent="flex-start" alignItems="space-between" flexDirection="row">
								<Box>
									<AlarmOnIcon style="margin-right: 10px;" />
								</Box>
								<Box>
									<Typography variant="h6">Rendez-vous confirmé</Typography>{" "}
								</Box>
							</Box>
						)}
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						{state.att &&
							state.att.map((att) => {
								return (
									<Box display="flex" justifyContent="flex-start" alignItems="center">
										<Box>
											<PersonIcon style="margin-right: 10px;" />
										</Box>
										<Box>
											<Typography variant="h6">{att.n}</Typography>{" "}
										</Box>
										{state.c && att.att !== null && (
											<Box>
												<Typography variant="h6">{att.att ? "Présent " : "Non présent"}</Typography>{" "}
												{att.att === true && (
													<Typography variant="h6">{att.aroused ? "Intéressé " : "Non Intéressé"}</Typography>
												)}
											</Box>
										)}
										{state.c && att.att === null && (
											<>
												<Box>
													<Button
														variant="contained"
														color="default"
														className={classes.button}
														startIcon={<EventBusyIcon />}
														onClick={() => {
															attendeeHere({
																uid: att.u,
																attended: false,
															});
														}}
													>
														Pas venu
													</Button>
												</Box>
												{attended !== true && (
													<Box>
														<Button
															variant="contained"
															color="default"
															className={classes.button}
															startIcon={<EventAvailableIcon />}
															onClick={() => {
																setAttended(true);
															}}
														>
															Venu
														</Button>
													</Box>
												)}
												{attended && (
													<>
														<Box>
															<ColorButton
																variant="contained"
																color="default"
																className={classes.button}
																startIcon={<InsertEmoticonIcon />}
																onClick={() => {
																	attendeeHere({
																		uid: att.u,
																		attended: true,
																		wants_to_bid: true,
																	});
																}}
															>
																Intéressé !
															</ColorButton>
														</Box>
														<Box>
															<Button
																variant="contained"
																color="default"
																className={classes.button}
																startIcon={<SentimentDissatisfiedIcon />}
																onClick={() => {
																	attendedeHere({
																		uid: att.u,
																		attended: true,
																		wants_to_bid: false,
																	});
																}}
															>
																Pas Intéressé
															</Button>
														</Box>
													</>
												)}
											</>
										)}
									</Box>
								);
							})}
					</Paper>
				</Grid>
			</Grid>
		</div>
	);
}
